import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { BackendApiService } from '../../../app/services/backend-api.service';
@Component({
  selector: 'app-oven-on-off-bar',
  templateUrl: './oven-on-off-bar.component.html',
  styleUrls: ['./oven-on-off-bar.component.scss'],
  standalone: true,
  imports: [CommonModule, MatTooltipModule]
})
export class OvenOnOffBarComponent implements OnInit {
  public barchartloading: boolean = false;
  public ovenBaseUrl = BaseUrlConstantsService.OVEN_BASE_URL;
  public barChartParameters: any=[
    {
      name: "Door Status",
      type: "bar",
      value: 0
    },{
    name: "Scavenging Exaust Fan",
    type: "bar",
    value: 0
  },
  {
    name: "Heater / Oven Status",
    type: "bar",
    value: 0
  },
  {
    name: "Blower 1",
    type: "bar",
    value: 0
  },
  {
    name: "Blower 2",
    type: "bar",
    value: 0
  }
  ];
  public clientId: any;
  public ovenId: any;
  public subsystemId: any;
  public role = localStorage.getItem("role");
  constructor(public service: BackendApiService) { 
    this.ovenId = localStorage.getItem("oven_id");
    this.subsystemId = localStorage.getItem("subsystem_id");
    if(this.role === "ADMIN"){
      this.clientId = localStorage.getItem("admin_client_id");
    }else{
      this.clientId = localStorage.getItem("user_id");
    }
  }
  ngOnInit(): void {
    
    this.getOnOFData()
  }
  getOnOFData(){
    this.service.getData(`${this.ovenBaseUrl}api/v1/oven-assets/param-door-fan-heater/${this.clientId}/${this.ovenId}/${this.subsystemId}`)
    .then((response:any) =>{
      console.log(response,'response');
      if(response.code === 200){
        for (let i = 0; i < response.data.length; i++) {
          this.barChartParameters[i].value = response.data[i].value;
        }
      }else{

      }
    })
    
  }
  

}
